import React, { Component } from "react";
import BQMap from "@/components/QMap";

// 地图
export default class Pc extends Component {
  render() {
    return <BQMap headerHeight="1.3751rem" />;
  }
}
